module.exports = "data:image/svg+xml,module.exports = '/ui/fonts/slick.svg';"